import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/android-chrome-192x192.png")